import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useRef } from 'react';
import { getTimeIsOver } from "./helper";
import { useInterval } from "../useInterval";
import { useFlag } from "../useFlag";
import { TimerType } from "./types";
var isTimeBetween = function isTimeBetween(target, start, end) {
  return target <= end && target >= start || target >= end && target <= start;
};
export var useTimerProgress = function useTimerProgress(_ref) {
  var timerType = _ref.timerType,
    interval = _ref.interval,
    startTime = _ref.startTime,
    endTime = _ref.endTime,
    onTimeOver = _ref.onTimeOver,
    onInterval = _ref.onInterval;
  var _useFlag = useFlag(false),
    _useFlag2 = _slicedToArray(_useFlag, 2),
    isRunning = _useFlag2[0],
    setIsRunning = _useFlag2[1];
  var time = useRef(startTime);
  var shouldResetTimeRef = useRef(false);
  var onReached = function onReached() {
    var previousTime = time.current;
    var timeValue = timerType === TimerType.INCREMENTAL ? previousTime + interval : previousTime - interval;
    time.current = timeValue;
    onInterval === null || onInterval === void 0 ? void 0 : onInterval(timeValue);
    if (getTimeIsOver(timerType, timeValue, endTime)) {
      shouldResetTimeRef.current = true;
      intervalParams.cancelInterval();
      if (typeof onTimeOver === 'function') {
        onTimeOver();
      }
    }
  };
  var intervalParams = useInterval(interval, {
    onCreate: setIsRunning.on,
    onCancel: setIsRunning.off,
    onReached: onReached
  });
  var resetTime = function resetTime(newTime) {
    if (!newTime) {
      time.current = startTime;
      return;
    }
    var start = timerType === TimerType.DECREMENTAL ? endTime || 0 : startTime;
    var end = timerType === TimerType.DECREMENTAL ? startTime : endTime || 0;
    time.current = isTimeBetween(newTime, start, end) ? newTime : startTime;
  };
  return _objectSpread({
    time: time,
    shouldResetTimeRef: shouldResetTimeRef,
    isRunning: isRunning,
    resetTime: resetTime
  }, intervalParams);
};